import React from "react";
import { Link } from "react-router-dom";
function PracticeArea() {
  return (
    <div>
      <section className="practice-section">
        <div className="divider"></div>

        <div className="container">
          <div className="row g-4 align-items-end">
            <div className="col-12 col-lg-6">
              {/* Section Heading */}
              <div className="section-heading">
                <div className="sub-title text-white">
                  <img src="assets/img/core-img/hammer.png" alt="" />
                  Practice Area
                </div>
                <h2 className="mb-0 text-white">
                  Tailored Comprehensive Legal Services
                </h2>
              </div>
            </div>

            <div className="col-12 col-lg-6">
              <div className="text-md-end">
                {/* Button */}
                <Link
                  className="btn btn-primary wow fadeInUp"
                  to="/casestudy"
                  data-wow-duration="1000ms"
                  data-wow-delay="700ms"
                >
                  <span>
                    View all Areas <i className="ti ti-arrow-up-right"></i>
                  </span>
                  <span>
                    View all Areas <i className="ti ti-arrow-up-right"></i>
                  </span>
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="divider-sm"></div>

        <div className="container">
          <div className="row g-4 g-lg-5">
            <div className="col-12">
              <div
                className="practice-item wow fadeInUp"
                data-wow-duration="1000ms"
                data-wow-delay="500ms"
              >
                <div>
                  <div className="d-flex align-items-center gap-3 mb-3">
                    <div className="practice-number">01</div>
                    <div className="practice-title">Criminal Defense</div>
                  </div>
                  <p className="mb-0 text-white">
                    Although we are located in Brooklyn, our maritime lawyers
                    are proud to help the injured throughout the nation,
                    including workers who were working in foreign waters at the
                    time of the incident go up against the largest offshore
                    companies and win.
                  </p>
                  <Link to="/casestudydetails" className="btn btn-primary mt-5">
                    <span>
                      Read More <i className="ti ti-arrow-up-right"></i>
                    </span>
                    <span>
                      Read More <i className="ti ti-arrow-up-right"></i>
                    </span>
                  </Link>
                </div>

                <div className="practice-img">
                  <img src="assets/img/bg-img/66.jpg" alt="" />
                </div>
              </div>
            </div>

            <div className="col-12">
              <div
                className="practice-item wow fadeInUp"
                data-wow-duration="1000ms"
                data-wow-delay="700ms"
              >
                <div>
                  <div className="d-flex align-items-center gap-3 mb-3">
                    <div className="practice-number">02</div>
                    <div className="practice-title">Family Law</div>
                  </div>
                  <p className="mb-0 text-white">
                    Although we are located in Brooklyn, our maritime lawyers
                    are proud to help the injured throughout the nation,
                    including workers who were working in foreign waters at the
                    time of the incident go up against the largest offshore
                    companies and win.
                  </p>
                  <Link to="/casestudydetails" className="btn btn-primary mt-5">
                    <span>
                      Read More <i className="ti ti-arrow-up-right"></i>
                    </span>
                    <span>
                      Read More <i className="ti ti-arrow-up-right"></i>
                    </span>
                  </Link>
                </div>

                <div className="practice-img">
                  <img src="assets/img/bg-img/67.jpg" alt="" />
                </div>
              </div>
            </div>

            <div className="col-12">
              <div
                className="practice-item wow fadeInUp"
                data-wow-duration="1000ms"
                data-wow-delay="900ms"
              >
                <div>
                  <div className="d-flex align-items-center gap-3 mb-3">
                    <div className="practice-number">03</div>
                    <div className="practice-title">Corporate Law</div>
                  </div>
                  <p className="mb-0 text-white">
                    Although we are located in Brooklyn, our maritime lawyers
                    are proud to help the injured throughout the nation,
                    including workers who were working in foreign waters at the
                    time of the incident go up against the largest offshore
                    companies and win.
                  </p>
                  <Link to="/casestudydetails" className="btn btn-primary mt-5">
                    <span>
                      Read More <i className="ti ti-arrow-up-right"></i>
                    </span>
                    <span>
                      Read More <i className="ti ti-arrow-up-right"></i>
                    </span>
                  </Link>
                </div>

                <div className="practice-img">
                  <img src="assets/img/bg-img/68.jpg" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="divider"></div>
      </section>
    </div>
  );
}

export default PracticeArea;
